import React from 'react';
import { NavContextProvider } from 'src/context/nav-context';
import { isLoggedIn } from '../services/user.service';
import { SideNav } from '../containers';
import TechnicalErrorSelfService from 'src/containers/self-service/technical-error-self-service/technical-error-self-service';

export function wrapWithNavigation(WrappedComponent) {
  return () => {
    if (isLoggedIn()) {
      return (
        <div className="full-height">
          <NavContextProvider>
            <div className="side-nav-container">
              <SideNav />
              <div className="main-container">
                <TechnicalErrorSelfService>
                  <WrappedComponent />
                </TechnicalErrorSelfService>
              </div>
            </div>
          </NavContextProvider>
        </div>
      );
    } else {
      return (
        <div>
          <WrappedComponent />
        </div>
      );
    }
  };
}
